import { ThemeConfig } from "../store/types";

export const defaultTheme: ThemeConfig = {
  primaryColor: "#6366f1",
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  fontSize: "16px",
  borderRadius: "16px",
  buttonBackground: "linear-gradient(45deg, #6366f1, #4f46e5)",
  buttonColor: "#ffffff",
  buttonSize: "96px",
  chatBackground: "#ffffff",
  userMessageBackground: "#6366f1",
  userMessageColor: "#ffffff",
  agentMessageBackground: "#f1f5f9",
  agentMessageColor: "#1e293b",
  statusBackground: "rgba(255, 255, 255, 0.95)",
  statusColor: "#1e293b",
};

export const getThemeValue = (
  theme: Partial<ThemeConfig> | undefined,
  key: keyof ThemeConfig
): string => {
  return theme?.[key] || defaultTheme[key];
};
